import axios from "axios";
import client from "./ApiService";
class GAService {
  constructor() {
    this.url = "/gav4";
  }

  getViewByID(id){
    return client.get(`${this.url}/getViewGA4ByID?increment_id=${id}`);
  }
}

export default new GAService();
